import { useEffect, useState } from "react";

// Components.
import AdminTrail from "./AdminTrail";

// Api.
import InstanceApi from "../../api/instance/InstanceApi";

// Helpers.
import { fetchResults, stringFormatting } from "../../helpers/utils";
import { showError } from "../../utils/showAlert";

type DatabaseTypeTrailProps = {
    // Label for the section crumb, e.g. "SQL Statistics".
    section: string
    // Route the section crumb links back to, e.g. "/admin/database-extended-statistics".
    sectionPath: string
}

// Trail for the admin sections keyed by database technology rather than by record
// id. The final crumb is the technology whose metrics are being edited, using the
// same display names as those sections' list tables.
const DatabaseTypeTrail = ({ section, sectionPath }: DatabaseTypeTrailProps) => {
    const [displayMap, setDisplayMap] = useState<Record<string, string>>({});

    useEffect(() => {
        const getDisplayNames = async() => {
            try {
                const results: any[][] = await fetchResults([InstanceApi.fetchTypes()]);
                const map: Record<string, string> = {};
                results[0].forEach((t: { type: string, display: string }) => {
                    map[t.type] = t.display;
                });
                setDisplayMap(map);
            } catch (error: any) {
                const errorMessage = error.message || error.toString();
                showError('Failed to load database types', errorMessage);
            }
        }

        getDisplayNames();
    }, []);

    return <AdminTrail section={section} sectionPath={sectionPath}
                       resolveEntityLabel={(type) => displayMap[type] || stringFormatting(type)}/>;
};

export default DatabaseTypeTrail;
